import type { SVGProps } from 'react';

export function BottleIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M13 1a2 2 0 0 1 2 2v2a5 5 0 0 0 1 3l.6.8A7 7 0 0 1 18 13v8a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-8c0-1.515.492-2.988 1.4-4.2L8 8a5 5 0 0 0 1-3V3a2 2 0 0 1 2-2zm-1.2 13c-.399 0-.82.117-1.165.376-.351.263-.635.691-.635 1.224v1.8c0 .533.284.96.635 1.224A1.95 1.95 0 0 0 11.8 19H15a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z" />
    </svg>
  );
}
